import { getApiBaseUrl } from '../config/constants';

export interface SiteConfig {
  tagline: string;
  section_heading: string;
  bullet1: string;
  bullet2: string;
  bullet3: string;
  meetings_enabled: boolean;
  /** Meeting code for /2026-workshop (e.g. SAA15). Set in Admin → Home. */
  workshop_2026_meeting_code?: string;
  /** When true + builder bypass email, SAA tab shows full meetings finder instead of 2026 card. */
  workshops_tab_show_full_finder?: boolean;
}

const DEFAULT_SITE_CONFIG: SiteConfig = {
  tagline: "Work your steps. Support your recovery. Give your meeting a home page.",
  section_heading: "What you'll find here",
  bullet1: "A place to track your 12 step work with guided actions, videos, and progress you own—so you keep your momentum.",
  bullet2: "A place where your meeting can have a home page: information, service, and group business in one place—where members can join and contribute.",
  bullet3: "Privacy and control: Your step work is encrypted and only you see it; you and your meeting control who sees meeting information.",
  meetings_enabled: true,
  workshop_2026_meeting_code: '',
  workshops_tab_show_full_finder: false,
};

/** Public: get site config for home page (no auth). */
export async function getSiteConfig(): Promise<SiteConfig> {
  try {
    const res = await fetch(`${getApiBaseUrl()}/site/config`, { cache: 'no-store' });
    if (!res.ok) return DEFAULT_SITE_CONFIG;
    const data = await res.json();
    return {
      tagline: data.tagline ?? DEFAULT_SITE_CONFIG.tagline,
      section_heading: data.section_heading ?? DEFAULT_SITE_CONFIG.section_heading,
      bullet1: data.bullet1 ?? DEFAULT_SITE_CONFIG.bullet1,
      bullet2: data.bullet2 ?? DEFAULT_SITE_CONFIG.bullet2,
      bullet3: data.bullet3 ?? DEFAULT_SITE_CONFIG.bullet3,
      meetings_enabled: data.meetings_enabled ?? DEFAULT_SITE_CONFIG.meetings_enabled,
      workshop_2026_meeting_code: data.workshop_2026_meeting_code ?? DEFAULT_SITE_CONFIG.workshop_2026_meeting_code,
      workshops_tab_show_full_finder: data.workshops_tab_show_full_finder ?? DEFAULT_SITE_CONFIG.workshops_tab_show_full_finder,
    };
  } catch {
    return DEFAULT_SITE_CONFIG;
  }
}

export { DEFAULT_SITE_CONFIG };
